<template>
	<div>
		<el-dialog  :visible.sync="showSupplierModify"   width="550px">
	<el-form :loading="loading" ref="form" :model="super_form"  :rules="rules" size="small" label-width="100px" style="text-align: left;">
	
	  <el-form-item label="供应商编号"  >
	    <el-input v-model="super_form.serialNumber" disabled="true" style="width: 370px;"/>
	  </el-form-item>
	  <el-form-item label="手机号码" >
	    <el-input v-model="super_form.supplierPhone" disabled="true" style="width: 370px;"/>
	  </el-form-item>
	  <el-form-item label="真实姓名" prop="supplierName" >
	    <el-input  v-model="super_form.supplierName" style="width: 370px;"/>
	  </el-form-item>
	  <el-form-item label="地区"  prop="area">
	    <div v-if="super_form.certificationStatus=='unreviewed'">
	      <el-cascader
	        v-model="super_form.area"
	        :options="options"
	      />
	    </div>
	    <div v-else>
	      <el-input  v-model="super_form.supplierArea" style="width: 370px;"/>
	
	    </div>
	  </el-form-item>
	  <el-form-item label="详细地址" prop="supplierDetailAddress" >
	    <el-input  v-model="super_form.supplierDetailAddress" style="width: 370px;"/>
	  </el-form-item>

	 <!-- <el-form-item label="申请时间" prop="sumbitTime" >
	    <el-date-picker
	     
	      v-model="super_form.sumbitTime"
	      type="datetime"
	      placeholder="选择日期时间"/>
	  </el-form-item> -->
	  <el-form-item label="身份证正面" style="width: 370px;" >
	    <div v-if="!super_form.positivePic">
	      <el-upload
	        :action="imagesUploadApi"
	        :limit="1"
	        :on-success="positivePicUpload"
	        :before-upload="beforeUpload"
	        :headers="headers"
	        class="upload-demo"
	        multiple
	      >
	        <el-button size="small" type="primary">点击上传</el-button>
	
	        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
	
	      </el-upload>
	    </div>
	    <div v-else>
	      <img :src="super_form.positivePic" style="width: 50px; height: 50px" @click="handlePictureCardPreviewSrc(super_form.positivePic)" >
	      <el-dialog :append-to-body="true" :visible.sync="dialogVisiblesrc">
	        <img :src="dialogImageUrlsrc" width="100%" alt="">
	      </el-dialog>
	    </div>
	  </el-form-item>

	  <el-form-item label="身份证号码"  prop="idCardNumber"  >
	    <el-input  v-model="super_form.idCardNumber" style="width: 370px;"/>
	  </el-form-item>
	  <el-form-item label="经营主体" prop="businessEntity" >
	    <el-input  v-model="super_form.businessEntity" style="width: 370px;"/>
	  </el-form-item>
	</el-form>
	 <span slot="footer" class="dialog-footer">
	    <el-button @click="showSupplierModify = false">取 消</el-button>
	    <el-button :loading="loading" type="primary" @click="doSubmit">确 定</el-button>
	  </span>
	</el-dialog>
	</div>
</template>

<script>
import checkPermission from '@/utils/permission'
import initDict from '@/mixins/initDict'
import options from './country-data.js'
import {edit} from '../../../api/supplier.js'
import {
  mapGetters
} from 'vuex'

import { parseTime } from '@/utils/index'
// import edit from './module/edit'
import {
  getToken
} from '@/utils/auth'
export default {
	props:{
		
		super_form:Object
		
		
	},
  mixins: [initDict],
  data() {

    return {
		imagesUploadApi:process.env.VUE_APP_API_URL+"/api/pictures",
	  showSupplierModify:false,
      dialogVisiblesrc: false,
      formDisable: false,
      headers: {
        'Authorization': 'Bearer ' + getToken()
      },
      options: options,
      delLoading: false, sup_this: this,
      EnterpriseName: [],
      form: {
        id: '',
        affiliatedCompany: [],
        serialNumber: '',
        supplierName: '',
        settlementAccountId: '',
        certificationStatus: '',
        workStatus: '',
        sumbitTime: '',
        idCardImg: '',
        idCardNumber: '',
        contract: '',
        supplierPhone: '',
        businessEntity: '',
        positivePic: '',
        backPic: '',
        area: '',
        supplierArea: '',
        supplierDetailAddress: '',
        yumiEnterpriseUsers: []
      },
      yumiEnterpriseUsersData: [],
      active: 0,
      loading: false,
      rules: {
        supplierName: [{
          required: true,
          trigger: 'blur',
          message: '真实姓名不能为空'
        }],
        area: [{
          required: true,
          trigger: 'blur',
          message: '地区不能为空'
        }],
        supplierDetailAddress: [{
          required: true,
          trigger: 'blur',
          message: '详细地址不能为空'
        }],
        idCardNumber: [{
          required: true,
          trigger: 'blur',
          message: '身份证号码不能为空'
        }],
        businessEntity: [{
          required: true,
          trigger: 'blur',
          message: '经营主体不能为空'
        }],
        sumbitTime: [{
          required: true,
          trigger: 'blur',
          message: '申请时间不能为空'
        }]
      }
    }
  },
  
  created() {
    this.$nextTick(() => {
      // this.init()
      this.getDictMap('supplier_audit_status,settlement_account,supplier_work_status')
     
    })
  },
  methods: {
    parseTime,
    checkPermission,

    setActive(certificationStatus) {
      if (certificationStatus != 'unreviewed') {
        this.formDisable = true
      }

      if (certificationStatus == 'unreviewed') {
        this.active = 0
      }
      if (certificationStatus == 'underReview') {
        this.active = 1
      }
      if (certificationStatus == 'audited') {
        this.active = 3
      }
    },
    backPicUpload(response) {
      this.form.backPic = response.data[0]
    },
    positivePicUpload(response) {
      this.super_form.positivePic = response.data[0]
    },
    doSubmit() {
      var s = ''
      for (var i = 0; i < this.super_form.area.length; i++) {
        if (i == this.super_form.area.length - 1) {
          s = s + this.super_form.area[i]
        } else {
          s = s + this.super_form.area[i] + '/'
        }
      }
      this.super_form.supplierArea = s

      if(this.super_form.positivePic==""){
        this.$alert('身份证【正面】照片不能为空', '提示', {
                  confirmButtonText: '确定',
                  });
                return false
      }
      

      this.super_form.idCardImg = this.super_form.positivePic
      this.super_form.certificationStatus = 'underReview'
     
      edit(this.super_form).then(res => {
        this.$notify({
          title: '提交成功',
          type: 'success',
          duration: 2500
        })
     
        this.loading = false

        // this.setActive('underReview')
        // this.init()
      }).catch(err => {
        this.loading = false
      })
    },
    handlePictureCardPreviewSrc(src) {
      this.dialogImageUrlsrc = src
      this.dialogVisiblesrc = true
    },
    beforeUpload(file){
              const isJPG = file.type === 'image/jpeg';
              const isPNG = file.type === 'image/png';
              const isLt5M = file.size / 1024 / 1024 < 5;

              if (!isJPG&&!isPNG) {
                this.$message.error('上传图片只能是 JPG/PNG 格式!');
              }
              if (!isLt5M) {
                this.$message.error('上传图片大小不能超过 5MB!');
              }
              return (isJPG||isPNG) && isLt5M;
    }
  }
}
</script>

<style scoped>

</style>
